module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAABHNCSVQICAgIfAhkiAAAAMxJREFUSIndlVsOgyAQRQ+NWzC6m+LK1JWJu7FhEfRDLEaLPFqbtudLmXjvODMA/DpiedAVwxvUxnKi2xnomg5D+7LBrNiUE2p5LY6CKegaiWEAJDiNS45YCoUvYDPyl00wAir0x14Di/RGDNKOSJ6BzUz44rGc3oNoA10jdX1QMg+hHjhcw1WKwfeUKJeUfSBhc2YJ+jP2wXqtD3wfvw+WzMsbTUh0zR83eYc93E4z2N5UsXysRApoMQy6ylQyz5fdGM738jVT/sF2jO+LMza/dlkXmQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/person/icon1ed.png
// module id = E+Bb
// module chunks = 1